import { render } from "./commissionsForecastComponent.vue?vue&type=template&id=53cd4d58"
import script from "./commissionsForecastComponent.vue?vue&type=script&lang=js"
export * from "./commissionsForecastComponent.vue?vue&type=script&lang=js"

import "./commissionsForecastComponent.vue?vue&type=style&index=0&id=53cd4d58&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__